import { Component, OnInit,Input, EventEmitter, Output } from '@angular/core';
import { KmsService } from 'src/app/areas/kms/kms.service';
import { KmsEnum } from 'src/app/areas/kms/serves/kms-enum';
import { DictionaryService } from 'src/app/librarys/serves/public/dictionary.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';

@Component({
  selector: 'app-rel-view',
  templateUrl: './rel-view.component.html',
  styleUrls: ['./rel-view.component.css']
})
export class RelViewComponent implements OnInit {
  //接收父组件的数据  
  @Input() id:any;                       // 属性主键id（自增长id）
  @Input() modelVerId:string;              // 模型版本id
  // 取消操作成功后向父组件发射数据
  @Output('relCancel') relCancel = new EventEmitter<any>();  
  formModel:any = {}; // 表单信息
  RelTypeCode = KmsEnum.KGS_RELATION_TYPE;
  constructor(
    private kmsService: KmsService,
    private dicService: DictionaryService,
    private message: SwMassageBoxService,
  ) { }

  ngOnInit() {
  }

  ngOnChanges() {
    // 根据主键查询概念信息
    this.kmsService.getConceptRelationById(this.id).subscribe(
      result => {
        if (result.code == 200) {
          this.formModel = result.data;
        }else{
          this.message.waring(result.msg);
        }
      }
    )
  }

  // 根据关系分类code获取名称
  getRelationTypeName(code){
    let options = this.dicService.getDictionaryTree(this.RelTypeCode,'dictionaryId','dictionaryName','parentId','dictionaryValue');
    let items = options.filter(el => el.value == code);
    return items.length>0 ? items[0].text : '无';
  }

  // 取消新增或编辑操作
  cancel(){
    this.relCancel.emit(true);
  }
}
